import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-label"]

import {onBeforeUnmount, onMounted, ref, watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'appModal',
  props: {
    modelValue: { type: Boolean },
    label: {},
    duration: { default: 150 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const dialogRef = ref<HTMLDialogElement | null>(null);

// The browser's top layer escapes clipping without leaving the current shadow tree.
const openDialog = () => {
  const dialog = dialogRef.value;
  if (props.modelValue && dialog && !dialog.open) dialog.showModal();
};

const closeDialog = () => {
  if (!props.modelValue) dialogRef.value?.close();
};

const requestClose = () => emit('update:modelValue', false);
const handleClose = () => {
  if (!dialogRef.value?.open && props.modelValue) requestClose();
};

onMounted(openDialog);
watch(() => props.modelValue, openDialog, {flush: 'post'});
onBeforeUnmount(() => dialogRef.value?.close());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "app-modal",
    "aria-label": __props.label,
    onCancel: _withModifiers(requestClose, ["prevent"]),
    onClose: handleClose,
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_Transition, {
      name: "app-modal-fade",
      duration: __props.duration,
      onAfterLeave: closeDialog
    }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle({transitionDuration: __props.duration + 'ms'})
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["duration"])
  ], 40, _hoisted_1))
}
}

})